<template>
  <div :class="{ 'has-error' : localErrors.has(this.name) }" @click="onClick" class="input-wrap activator-wrapper">
    <input :value="value"
           :name="name"
           v-bind="$attrs"
           :class="inputClass"
           class="text-field"
           type="text">
    <span v-if="picker.showActivatorBar" class="bar"></span>
    <label v-if="picker.showActivatorLabel">{{ this.$t('Select Date') }}</label>
    <label v-show="localErrors.has(this.name)" class="help-text">{{ localErrors.first(this.name) }}</label>
  </div>
</template>

<script>
export default {
  name: 'CustomActivator',

  inheritAttrs: false,

  inject: ['picker'],

  props: ['value', 'name', 'errorsBag'],

  data: function() {
    return {
      localErrors: this.errorsBag
    };
  },

  computed: {
    inputClass () {
      return {
        'text-field__filled': this.value && this.value.trim().length > 0,
      };
    },
  },

  created: function () {
    this.localErrors = this.errorsBag || this.errors;
  },

    methods: {
        onClick(event) {
            this.$emit('click', event);
        },
    }
};
</script>
